import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const subways = [
  { line: '1호선', color: 'bg-blue-600', station: '동대문역', exit: '7번 출구', walk: '도보 3분' },
  { line: '4호선', color: 'bg-sky-500', station: '동대문역', exit: '7번 출구', walk: '도보 3분' },
  { line: '2호선', color: 'bg-green-500', station: '동대문역사문화공원역', exit: '14번 출구', walk: '도보 5분' },
  { line: '5호선', color: 'bg-violet-500', station: '동대문역사문화공원역', exit: '14번 출구', walk: '도보 5분' },
];

const buses = [
  { type: '간선버스', color: 'bg-blue-500', numbers: '105, 107, 108, 140, 143, 144, 145, 148, 150, 152' },
  { type: '지선버스', color: 'bg-green-500', numbers: '2012, 2014, 2015, 7212' },
  { type: '광역버스', color: 'bg-red-500', numbers: '9403' },
];

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const directionsSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${SITE_URL}/directions`,
  url: `${SITE_URL}/directions`,
  name: '오시는 길 | 영빈호텔',
  description: '서울 종로구 종로 266 영빈호텔 오시는 길. 동대문역 7번 출구 도보 3분, 지하철 1·4호선 이용 가능.',
  isPartOf: { '@id': `${SITE_URL}/#website` },
  about: {
    '@type': 'Hotel',
    name: '영빈호텔',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '종로 266',
      addressLocality: '종로구',
      addressRegion: '서울특별시',
      postalCode: '03141',
      addressCountry: 'KR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 37.5636,
      longitude: 127.0086,
    },
    telephone: '+82-2-2277-1141',
    hasMap: 'https://maps.google.com/?q=서울특별시+종로구+종로+266+영빈호텔',
  },
};

const DirectionsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '오시는 길 | 영빈호텔 YOUNGBIN HOTEL';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '서울 종로구 종로 266 영빈호텔 오시는 길. 동대문역 7번 출구 도보 3분, 지하철 1·4호선 이용 가능. TEL: 02-2277-1141');
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-directions';
    script.textContent = JSON.stringify(directionsSchema);
    document.head.appendChild(script);
    return () => {
      document.title = '영빈호텔 | YOUNGBIN HOTEL';
      if (metaDesc) metaDesc.setAttribute('content', '서울 중구 동대문 영빈호텔. 동대문 쇼핑상가 도보 10분, 사우나·무료와이파이·24시간 컨시어지 제공. TEL: 02-2277-1141');
      const el = document.getElementById('schema-directions');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Sub Header */}
      <div className="pt-20 bg-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <p className="text-amber-400 text-xs tracking-[0.3em] uppercase mb-2">DIRECTIONS</p>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            오시는 길
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto px-6 py-16">

        {/* 주소 정보 */}
        <div className="flex flex-col md:flex-row gap-6 mb-12">
          {[
            { icon: 'ri-map-pin-2-line', title: '주소', desc: '서울특별시 종로구 종로 266\n(구주소: 서울 종로구 창신동 581-1)' },
            { icon: 'ri-phone-line', title: '전화', desc: '02-2277-1141' },
            { icon: 'ri-time-line', title: '체크인 / 체크아웃', desc: '체크인 15:00\n체크아웃 12:00' },
          ].map((item) => (
            <div key={item.title} className="flex-1 flex items-start gap-4 bg-stone-50 rounded-xl p-5 border border-stone-100">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                <i className={`${item.icon} text-amber-700 text-lg`} />
              </div>
              <div>
                <p className="text-xs text-amber-700 font-semibold tracking-widest uppercase mb-1">{item.title}</p>
                <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 지도 */}
        <div className="w-full h-[420px] rounded-xl overflow-hidden border border-stone-200 mb-14">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.5!2d127.0097!3d37.5714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2f0e3b3b3b3%3A0x0!2z7Jyg67mM7Zi47YSw7Iqk!5e0!3m2!1sko!2skr!4v1700000000000!5m2!1sko!2skr&q=서울특별시+종로구+종로+266+영빈호텔"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="영빈호텔 지도"
          />
        </div>

        {/* 지하철 */}
        <div className="mb-12">
          <h2 className="text-base font-bold text-gray-900 mb-5 flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center bg-stone-100 rounded-full">
              <i className="ri-subway-line text-stone-600 text-sm" />
            </div>
            지하철 이용 시
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {subways.map((s) => (
              <div key={s.line + s.station} className="flex items-center gap-4 bg-stone-50 rounded-xl p-4 border border-stone-100">
                <span className={`${s.color} text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap`}>{s.line}</span>
                <div>
                  <p className="text-sm font-semibold text-gray-800">{s.station} {s.exit}</p>
                  <p className="text-xs text-amber-600 mt-0.5">{s.walk}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 버스 */}
        <div className="mb-12">
          <h2 className="text-base font-bold text-gray-900 mb-5 flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center bg-stone-100 rounded-full">
              <i className="ri-bus-line text-stone-600 text-sm" />
            </div>
            버스 이용 시
          </h2>
          <div className="flex flex-col gap-4">
            {buses.map((b) => (
              <div key={b.type} className="flex items-start gap-4 bg-stone-50 rounded-xl p-4 border border-stone-100">
                <span className={`${b.color} text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap flex-shrink-0`}>{b.type}</span>
                <p className="text-sm text-gray-600 leading-relaxed">{b.numbers}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 자가용 */}
        <div className="mb-14">
          <h2 className="text-base font-bold text-gray-900 mb-5 flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center bg-stone-100 rounded-full">
              <i className="ri-car-line text-stone-600 text-sm" />
            </div>
            자가용 이용 시
          </h2>
          <div className="bg-stone-50 rounded-xl p-6 border border-stone-100">
            <ul className="flex flex-col gap-3">
              {[
                '내비게이션에 "영빈호텔" 또는 "서울 종로구 종로 266" 입력',
                '동대문 방면 종로 방향으로 진입 후 호텔 간판 확인',
                '호텔 인근 공영주차장 이용 가능 (유료)',
              ].map((tip) => (
                <li key={tip} className="flex items-start gap-2 text-sm text-gray-600">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-arrow-right-s-line text-amber-500" />
                  </div>
                  {tip}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Back */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 border border-stone-300 text-gray-700 rounded-full text-sm hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            메인으로 돌아가기
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DirectionsPage;
